<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- <div class="nav-bar">
    <div class="nav-item" @click="goTo('/main')">Alpha π计划</div>
    <div class="nav-item" @click="goTo('/domp')">Viva la différence</div>
    <div class="nav-item" @click="goTo('/domp/YeasCard')">关于阳狮</div>
  </div> -->
  <div class="box">
    <img class="topleft" src="@/assets/dlbe.png" alt="">
    <img class="bottomleft" src="@/assets/tou.png" alt="">
    <img class="bottomright" src="@/assets/ewm.png" alt="">
    <img class="btopmain" src="@/assets/title.png" alt="">
    <img class="main" src="@/assets/titlemin.png" alt="">
    <img class="bottom" @click="goMain" src="@/assets/button.png" alt="">
    <img class="ytopleft" src="@/assets/ydlbr.png" alt="">
    <img class="ytopright" src="@/assets/ydlby.png" alt="">
    <img class="ybottomleft" src="@/assets/ydlbz.png" alt="">
    <img class="ybottomrightrx" src="@/assets/yrx.png" alt="">
    <img class="ybottomright" src="@/assets/yzx.png" alt="">
    <img class="yewm" src="@/assets/yewm.png" alt="">
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()

const goMain = () => {
  router.push('/main')
}

</script>

<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  z-index: 9999;
}

.nav-item {
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: color 0.3s ease;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
}

.nav-item:hover {
  color: #ff4d4f;
}

.box {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
}

img {
  display: block;
  height: auto;
}

.topleft {
  position: absolute;
  left: 0;
  top: 0;
  width: 15%;
}

.bottomleft {
  position: absolute;
  left: 3%;
  bottom: 0;
  width: 30%;
}

.bottomright {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 28%;
}

.btopmain {
  position: absolute;
  top: 9%;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 40%;
}

.main {
  position: absolute;
  top: 55%;
  left: 53%;
  transform: translate(-50%, -50%);
  width: 25%;
}

.bottom {
  position: absolute;
  top: 87%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 27%;
  z-index: 999;
   transition: all 0.2s ease;
   cursor: pointer;
   animation: breathe 1.8s infinite ease-in-out;
}
@keyframes breathe {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.08);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
.bottom:active {
  transform: translate(-50%, -50%) scale(0.9);
  opacity: 0.9; /* 微微变暗 */
}

.ybottomleft,
.ytopleft,
.ybottomright,
.ybottomrightrx,
.yewm,
.ytopright {
  display: none;
}

@media (max-width: 768px) {
  .nav-bar {
    height: 50px;
    gap: 15px;
    padding: 0 10px;
  }
  
  .nav-item {
    font-size: 12px;
  }

  .bottomleft,
  .topleft,
  .bottomright {
    display: none;
  }

  .ytopleft {
    position: absolute;
    left: 0;
    top: 0;
    width: 25%;
    display: block;
  }

  .ytopright {
    position: absolute;
    right: 0;
    top: 0;
    width: 25%;
    display: block;
  }

  .ybottomleft {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 25%;
    display: block;
  }

  .btopmain {
    position: absolute;
    width: 80%;
    height: auto;
    top: 23%;
  }

  .ybottomright {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 75%;
    display: block;
  }

  .ybottomrightrx {
    position: absolute;
    right: 0;
    bottom: 98px;
    width: 43%;
    display: block;
  }

  .yewm {
    position: absolute;
    left: 10%;
    bottom: 28%;
    width: 21%;
    display: block;
  }

  .main {
    position: absolute;
    width: 40%;
    top: 45%;
    left: 31%;
  }

  .bottom {
    position: absolute;
    width: 44%;
    top: 79%;
    left: 31%;
  }
}
</style>